import React from "react";
import { AddPanelSkypeGrop } from "../../../UI/Groups/Skype/Add/AddPanelSkypeGrop";

const AddSkypeGroup = () => {
  return (
    <div>
      <AddPanelSkypeGrop />
    </div>
  );
};

export default React.memo(AddSkypeGroup);
